import { Input, Label, Textarea } from "@fluentui/react-components";
import { ArrowCircleLeftRegular } from "@fluentui/react-icons";
import * as React from "react";


function AskLegal(props){
  console.log(props)
    const [fromFields, setFromFields] = React.useState({});

    function handleOnChange(event, item) {
        setFromFields((prev) => {
          const temp = { ...prev };
          temp[item] = event.target.value;
          return temp;
        });
      }

    return(

        <>
           {/* <div className="BackButtonContainer">
        <ArrowCircleLeftRegular onClick={()=>props.setisAskLegal(false)}/>
        </div> */}
        <div className="formFieldSection">
          <Label>{"Query"}</Label>
          <Textarea aria-label={"Query"} onChange={(event) => handleOnChange(event, "Query")} />
        </div>
        <div className="formFieldSection">
          <Label>{"Counterparty (if any)"}</Label>
          <Input aria-label={"Counterparty"} onChange={(event) => handleOnChange(event, "Counterparty")} />
        </div>
        
        </>
    )
}

export default AskLegal;